import React, { useEffect, useState } from "react";
import axios from "axios";
import { CourseCatalog } from "./CourseCatalog";

const API = "/backend/public/api";

function Courses() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    let active = true;

    axios
      .get(`${API}/courses-public`)
      .then((res) => {
        if (active) {
          const rows = Array.isArray(res.data) ? res.data : [];
          setCourses(rows.slice(0, 3));
        }
      })
      .catch(() => {
        if (active) {
          setCourses([]);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  return (
    <div id="courses" className="container py-5">
      <h2 className="text-center mb-5">Trending Course</h2>
      <CourseCatalog courses={courses.filter((course) => course.is_trending).slice(0, 8)} emptyMessage="Trending courses will appear here soon." columns={{ desktop: 4, tablet: 2, mobile: 1 }} itemsPerPage={8} />
    </div>
  );
}

export default Courses;



